import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Navigation } from "swiper/modules";

import type { bigReadContentQueue$key } from "scmp-app/queries/__generated__/bigReadContentQueue.graphql";
import type { CustomQueryParameters } from "scmp-app/types/gtm";

import {
  Container,
  StyledChevronNext,
  StyledChevronPrevious,
  StyledContentItemPostiesPrimary,
  StyledSwiper,
  StyledSwiperSlide,
  StyledSwiperWrapper,
  SwiperButton,
  swiperElementClasses,
} from "./styles";

type Props = {
  customQueryParameters?: CustomQueryParameters;
  reference: bigReadContentQueue$key;
};

export const BigReadContent: FunctionComponent<Props> = ({
  customQueryParameters,
  reference: reference_,
}) => {
  const queue = useFragment<bigReadContentQueue$key>(
    graphql`
      fragment bigReadContentQueue on Queue {
        items(first: 2) {
          edges {
            node {
              ... on Article {
                ...postiesPrimaryContentItemContent
              }
            }
          }
        }
      }
    `,
    reference_,
  );

  return (
    <Container>
      <StyledSwiperWrapper>
        <StyledSwiper
          autoplay={{
            delay: 8000,
            disableOnInteraction: false,
          }}
          cssMode={false}
          loop
          modules={[Autoplay, Navigation]}
          navigation={{
            nextEl: `.${swiperElementClasses.next}`,
            prevEl: `.${swiperElementClasses.previous}`,
          }}
        >
          {queue?.items?.edges.map(({ node }, key) => (
            <StyledSwiperSlide key={key}>
              <StyledContentItemPostiesPrimary
                customQueryParameters={customQueryParameters}
                reference={node}
              />
            </StyledSwiperSlide>
          ))}
        </StyledSwiper>
        <SwiperButton className={swiperElementClasses.previous}>
          <StyledChevronPrevious />
        </SwiperButton>
        <SwiperButton className={swiperElementClasses.next}>
          <StyledChevronNext />
        </SwiperButton>
      </StyledSwiperWrapper>
    </Container>
  );
};

BigReadContent.displayName = "BigReadContent";
